import countries from "../data/countries_states_cities.json";


// Create a function to check image dimensions
export const checkImageDimensions = (file) => {
  return new Promise((resolve, reject) => {
    const img = document.createElement("img");
    const objectUrl = URL.createObjectURL(file);

    img.onload = function () {
      const dimensions = {
        width: img.width,
        height: img.height,
      };
      URL.revokeObjectURL(objectUrl);
      resolve(dimensions);
    };

    img.onerror = function () {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to load image"));
    };

    img.src = objectUrl;
  });
};

// export function mapUIVariantsToApi(productVariants) {
//   if (!Array.isArray(productVariants)) return [];

//   let sortOrder = 0;

//   return productVariants.flatMap((variant) =>
//     (variant.options || [])
//       .filter((group) => Array.isArray(group.options) && group.options.length)
//       .map((group) => ({
//         ...group,
//         status: true,
//         name: group.name, // Colors, Sizes
//         options: group.options.join("|"), // ✅ "Red|Green|Blue"
//         optionImages: Array.isArray(group.optionImages)
//           ? group.optionImages.filter((img) => img && img.trim()).join("|")
//           : "",
//         sortOrder: sortOrder++,
//       })),
//   );
// }

// export function mapApiVariantsToUI(apiVariants) {
//     if (!Array.isArray(apiVariants) || apiVariants.length === 0) return [];

//     return [
//         {
//             name: "Variant One", // or apiVariants[0]?.variantName if exists
//             sortOrder: 0,
//             status: true,

//             options: apiVariants.map((v) => ({
//                 name: v.name,

//                 options: v.options
//                     ? v.options.split("|").map(o => o.trim()).filter(Boolean)
//                     : [],

//                 allOptions: v.options
//                     ? v.options.split("|").filter(Boolean)
//                     : [],

//                 optionImages: v.optionImages
//                     ? v.optionImages.split("|").filter(Boolean)
//                     : [],

//                 optionImagesPreview: v.optionImages
//                     ? v.optionImages.split("|").filter(Boolean)
//                     : []
//             }))
//         }
//     ];
// }

// export function mapApiVariantsToUI(apiVariants) {
//   if (!Array.isArray(apiVariants)) return {};

//   return apiVariants.reduce((acc, v) => {
//     acc[v.name] = v.options
//       ? v.options
//           .split("|")
//           .map((o) => o.trim())
//           .filter(Boolean)
//       : [];
//     return acc;
//   }, {});
// }

export function mapApiVariantsToUI(apiVariants) {
  if (!Array.isArray(apiVariants)) return {};

  return apiVariants.reduce((acc, v) => {
    acc[v.name] = {
      options: v.options
        ? v.options
            .split("|")
            .map((o) => o.trim())
            .filter(Boolean)
        : [],
      showImage: v.showImage ?? false,
    };

    return acc;
  }, {});
}

export function mapUIVariantsToApi(productVariants) {
  if (!Array.isArray(productVariants)) return [];

  let sortOrder = 0;

  return productVariants.flatMap((variant) =>
    (variant.options || [])
      .filter((group) => Array.isArray(group.options) && group.options.length)
      .map((group) => {
        // Parse the original oiMapping
        const mappingObj = parseOiMapping(group.oiMapping);

        // Filter mapping by selected options
        const filteredMapping = group.options.reduce((acc, selected) => {
          if (mappingObj[selected]) {
            acc[selected] = mappingObj[selected];
          }
          return acc;
        }, {});

        return {
          ...group,
          status: true,
          name: group.name, // Colors, Sizes
          options: group.options.join("|"), // "Red|Green"
          optionImages: Object.values(filteredMapping)
            .map((img) => img && img.trim())
            .filter(Boolean)
            .join("|"),
          oiMapping: buildOiMappingString(filteredMapping), // ✅ Only selected options
          sortOrder: sortOrder++,
        };
      }),
  );
}

export const parseOiMapping = (mappingString) => {
  if (!mappingString) return {};

  return mappingString.split("|").reduce((acc, pair) => {
    const [key, value] = pair.split("=");
    if (key && value) {
      acc[key.trim()] = value.trim();
    }
    return acc;
  }, {});
};

export const buildOiMappingString = (mappingObj) => {
  if (!mappingObj) return "";

  return Object.entries(mappingObj)
    .filter(([key, value]) => key && value)
    .map(([key, value]) => `${key}=${value}`)
    .join("|");
};

export const cleanHtml = (html) => {
  if (!html) return "";

  let content = html.trim();

  // remove &nbsp;
  content = content.replace(/&nbsp;/g, "").trim();

  // regex for empty <p>
  const emptyPRegex = /<p>\s*(<br\s*\/?>)?\s*<\/p>/gi;

  // ✅ if whole content is only empty <p> tags → return ""
  if (content.replace(emptyPRegex, "").trim() === "") {
    return "";
  }

  return html; // keep original if user added real content
};


export function getCountries() {
  return countries.map((c) => ({ id: c.id, name: c.name, iso2: c.iso2 }));
}

// ✅ Get states by country ISO2 code (e.g., "AF")
export function getStatesByCountry(countryCode) {
  const country = countries.find((c) => c.name === countryCode);
  return country
    ? country.states
        // ?.filter(
        //   (d) =>
        //     d.name?.trim() !== "Islamabad" &&
        //     d.name?.trim() !== "Federally Administered Tribal Areas"
        // )
        ?.map((s) => ({
          id: s.id,
          name: s.name,
          code: s.state_code,
        }))
    : [];
}

// ✅ Get cities by state code (within a country)
export function getCitiesByState(countryCode, stateCode) {
  const country = countries.find((c) => c.name === countryCode);
  if (!country) return [];

  const state = country.states.find((s) => s.name === stateCode);
  return state
    ? state.cities.map((city) => ({ id: city.id, name: city.name }))
    : [];
}